import { Component } from '@angular/core';

@Component({
  selector: 'app-homegrown-banner',
  imports: [],
  templateUrl: './homegrown-banner.html',
})
export class HomegrownBanner {}
